const useDatasetsList = (datasetList) => {

    const updateStateData = (index, data) => {
        const copyData = [...datasetList]
        copyData[index] = data
        return copyData
    }

    const removeStateData = (index) => datasetList.filter((item, itemIndex) => index !== itemIndex)


    const updateDataset = (index, data) => data ? updateStateData(index, data) : removeStateData(index)
    
    return {
        updateDataset
    }
}

export default useDatasetsList